
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/cart",
      function () {
        return require("private-next-pages/default/desktop/cart.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/default/desktop/cart"])
      });
    }
  